/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';

import ProjectileEnum from 'astro/enum/projectile';
import * as Influence from 'astro/util/influence';


export default class extends BasicUnit
{
  canFireProjectiles ()
  {
    return true;
  }


  getProjectileType ()
  {
    return ProjectileEnum.LaserBattery;
  }


}
